<template>
  <div
    :class="{
      'osk-cart-order': true,
      'osk-cart-order_full': full,
    }"
  >
    <div
      v-if="!full"
      class="osk-cart-order__title"
    >
      {{ $t('components.cart.cartOrder.title') }}
      <template v-if="data.id">
        №{{ data.id }}
      </template>
    </div>

    <div class="osk-cart-order__left">
      <div
        v-if="full"
        class="osk-cart-order__header"
      >
        <UikitUser
          v-if="data.seller"
          :user="data.seller"
          size="s"
          class="osk-cart-order__header-seller"
          @user-click="handleUserClick"
        />

        <UikitButton
          v-if="isUnfinished && data.deletable"
          icon="Cross"
          color="none"
          class="osk-cart-order__delete-order"
          style="margin-bottom: -10px;"
          @click="handleOrderDelete(data.id!)"
        />
      </div>

      <div class="osk-cart-order__products">
        <UikitLoaderInner v-if="loadingComp" />

        <div
          v-for="item in items"
          :key="item.id"
          class="osk-cart-order__product"
        >
          <div class="osk-cart-order__product-card">
            <div class="osk-cart-order__product-image-wrapper">
              <img
                class="osk-cart-order__product-image"
                :src="item.imageUrl"
                :alt="item.productName"
              >
            </div>

            <div class="osk-cart-order__product-content">
              <div class="osk-cart-order__product-data">
                <span class="osk-cart-order__brand-name">
                  {{ item.brandName }}
                </span>

                <nuxt-link
                  v-if="full || isThanksPage"
                  :to="`/products/${item.productId}`"
                  class="osk-cart-order__product-name osk-cart-order__product-name-link"
                  @click="handleProductClick(item.productId)"
                >
                  {{ item.productName }}
                  <template v-if="item.productModel?.name">
                    {{ item.productModel.name }}
                  </template>
                </nuxt-link>

                <span
                  v-else
                  class="osk-cart-order__product-name"
                >
                  {{ item.productName }}
                  <template v-if="item.productModel?.name">
                    {{ item.productModel.name }}
                  </template>
                </span>

                <span class="osk-cart-order__product-id">
                  ID Oskelly: {{ item.productId }}
                </span>

                <div
                  v-if="full"
                  class="osk-cart-order__product-info_mobile"
                >
                  <div
                    v-if="isUnfinished || !canShowSelectAmount(item)"
                    :class="{
                      'osk-cart-order__label': true,
                    }"
                  >
                    {{ $t('components.cart.cartOrder.count', {count: item.count}) }}
                  </div>

                  <ProductAmountPicker
                    v-else
                    name="count"
                    :product="item"
                    small
                    :loading="loadingAmountId === item.id"
                    @update="changeCount($event, item)"
                  />

                  <div
                    :class="{
                      'osk-cart-order__label': true,
                      'osk-cart-order__label_active': !isUnfinished && canShowSelectSize(item),
                    }"
                    @click="!isUnfinished && canShowSelectSize(item) && openDialog(item)"
                  >
                    {{ item.size?.value }}
                  </div>
                </div>

                <div
                  v-if="full"
                  class="osk-cart-order__product-prices osk-cart-order__product-prices_full"
                >
                  <span
                    v-if="item.discount"
                    class="osk-cart-order__price-discount osk-cart-order__price-discount_full"
                  >
                    -{{ item.discount }}%
                  </span>

                  <span
                    v-if="item.rrp"
                    class="osk-cart-order__rrp osk-cart-order__rrp_full"
                  >
                    {{ numberToCurrency(item.rrp) }}
                  </span>

                  <span
                    v-if="item.amount"
                    class="osk-cart-order__price"
                  >
                    {{ numberToCurrency(item.amount) }}
                  </span>
                </div>
              </div>

              <div class="osk-cart-order__product-info">
                <div
                  v-if="full"
                  class="osk-cart-order__product-info_desktop"
                >
                  <div class="osk-cart-order__product-info-title">
                    {{ $t('components.cart.cartOrder.size') }}
                  </div>

                  <div class="osk-cart-order__product-info-size">
                    <span class="osk-cart-order__product-info-bold">
                      {{ item.size?.value }}
                    </span>

                    <span
                      v-if="!isUnfinished"
                      class="osk-cart-order__product-info-link"
                      @click="openDialog(item)"
                    >{{ $t('common.change') }}</span>
                  </div>

                  <div class="osk-cart-order__product-info-title">
                    {{ $t('components.cart.cartOrder.productInfo.title') }}
                  </div>

                  <div>
                    <span class="osk-cart-order__product-info-bold">
                      {{ getQuantity(item) }}
                    </span>

                    <span
                      v-if="!isUnfinished"
                      class="osk-cart-order__product-info-link"
                      @click="openDialog(item)"
                    >{{ $t('common.change') }}</span>
                  </div>
                </div>

                <template v-if="!full">
                  <div class="osk-cart-order__label">
                    {{ $t('components.cart.cartOrder.count', { count: item.count }) }}
                  </div>

                  <div
                    v-if="item.size?.value"
                    class="osk-cart-order__label"
                  >
                    {{ item.size?.value }}
                  </div>
                </template>
              </div>

              <div
                v-if="!full"
                class="osk-cart-order__product-prices"
              >
                <span
                  v-if="item.rrp"
                  class="osk-cart-order__rrp"
                >
                  {{ numberToCurrency(item.rrp) }}
                </span>

                <span
                  v-if="item.amount"
                  class="osk-cart-order__price"
                >
                  {{ numberToCurrency(item.amount) }}
                  <span
                    v-if="item.discount"
                    class="osk-cart-order__price-discount"
                  >
                    -{{ item.discount }}%
                  </span>
                </span>
              </div>
            </div>

            <div
              v-if="full && isMounted && isDesktop"
              class="osk-cart-order__buttons"
            >
              <UikitUserLikesCount
                class="osk-cart-order__product-info-wishlist"
                :is-liked="item.isLiked"
                :product-id="item.productId!"
                hide-count
                @dislike="toggleLike"
                @like="toggleLike"
              />

              <UikitButton
                v-if="!isUnfinished"
                icon="Cross"
                color="none"
                class="osk-cart-order__delete-product"
                @click="deleteProduct(item.id!, item)"
              />
            </div>
          </div>

          <div
            v-if="full && isMounted && !isDesktop"
            class="osk-cart-order__buttons osk-cart-order__buttons_mobile"
          >
            <UikitUserLikesCount
              class="osk-cart-order__product-info-wishlist"
              :is-liked="item.isLiked"
              :product-id="item.productId!"
              hide-count
              @dislike="toggleLike"
              @like="toggleLike"
            />

            <UikitButton
              v-if="!isUnfinished"
              icon="Cross"
              color="none"
              class="osk-cart-order__delete-product"
              @click="deleteProduct(item.id!, item)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="osk-cart-order__right">
      <div
        v-if="full"
        class="osk-cart-order__title"
      >
        {{ $t('components.cart.cartOrder.title') }}
        <template v-if="data.id">
          №{{ data.id }}
        </template>
      </div>

      <div class="osk-cart-order__items">
        <div
          v-if="data.count && data.clearAmount"
          class="osk-cart-order__item"
        >
          <span class="osk-cart-order__item-name">
            {{ $t('components.cart.cartOrder.totalCount', data.count) }}
          </span>

          <span class="osk-cart-order__item-result">
            {{ numberToCurrency(data.clearAmount) }}
          </span>
        </div>

        <div
          v-if="isDiscountWork"
          class="osk-cart-order__item"
        >
          <span class="osk-cart-order__item-name">
            {{ $t('components.cart.cartOrder.promocode') }}
          </span>

          <span class="osk-cart-order__item-result text-green">
            &ndash; {{ numberToCurrency(discount!.savingsValue!) }}
          </span>
        </div>

        <div class="osk-cart-order__item">
          <span class="osk-cart-order__item-name">{{ $t('components.cart.cartOrder.orderItem.delivery') }}</span>
          <span class="osk-cart-order__item-result">
            <template v-if="showFromDelivery">от&nbsp;</template>{{ numberToCurrency(deliveryCost!) }}
          </span>
        </div>

        <div class="osk-cart-order__item">
          <span class="osk-cart-order__item-name">{{ $t('components.cart.cartOrder.orderItem.expertise') }}</span>
          <span class="osk-cart-order__item-result">
            {{ $t('components.cart.cartOrder.orderItem.expertise.value') }}
          </span>
        </div>

        <div class="osk-cart-order__item">
          <span class="osk-cart-order__item-name">{{ $t('components.cart.cartOrder.orderItem.packing') }}</span>
          <span class="osk-cart-order__item-result">
            {{ $t('components.cart.cartOrder.orderItem.packing.value') }}
          </span>
        </div>

        <div class="osk-cart-order__item">
          <span class="osk-cart-order__item-name text-bold">{{ $t('components.cart.cartOrder.orderItem.total') }}</span>
          <span class="osk-cart-order__item-result">
            {{ numberToCurrency(totalAmount) }}
          </span>
        </div>
      </div>

      <UikitForm
        v-if="!data.id && !hidePromo"
        class="osk-cart-order__promo-form"
        @submit-validate-success="submitPromo"
      >
        <UikitFormInput
          class="osk-cart-order__promo-form-input"
          name="promoCode"
          :placeholder="$t('components.cart.cartOrder.promocode.placeholder')"
          required
        />

        <UikitButton
          :icon="isDiscountWork ? 'Check' : 'ArrowRight'"
          :color="isDiscountWork ? 'green' : undefined"
          :icon-color="isDiscountWork ? 'white' : undefined"
          class="osk-cart-order__promo-form-button"
          :loading="loadingPromo"
        />
      </UikitForm>

      <template v-if="showWebToAppBanner">
        <WebToAppDownloadAppMobileTop
          v-if="$device.isMobile"
          with-logo
          app-link="https://oskelly.onelink.me/kabM/xsxpw01t"
        />

        <WebToAppDownloadAppMobileTop
          v-else
          class="osk-mb-lg"
          :promo-text="$t('cart.cartOrder.webToApp.promoText', { sale })"
          :with-btn="false"
          with-logo
          dense
        >
          <template #qr-code>
            <img
              src="~/assets/img/webToApp/qr_checkout_under_promocode.png"
              height="38px"
              width="38px"
              alt="qr-code"
            >
          </template>
        </WebToAppDownloadAppMobileTop>
      </template>

      <div
        v-if="!hideButton"
        class="osk-cart-order__footer"
      >
        <UikitButton
          class="osk-cart-order__button"
          full-width
          :loading="loading"
          @click="handleClick"
        >
          <slot name="pay-button-content">
            {{ buttonTextComp }}

            <template v-if="showButtonPrice && totalAmount">
              {{ numberToCurrency(totalAmount) }}
            </template>
          </slot>
        </UikitButton>

        <slot name="pay-button-after" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCart } from '~/services/cart';
import { useApi } from '~/restAPI';
import {
  OrderDTO, OrderPositionDTORes,
} from '~/restAPI/data-contracts';
import { Cart } from '~/restAPI/Cart';
import { isCustomHTTPError } from '@/restAPI/error';
import { AnalyticsEvents } from '~/types/analytics';
import type { TSubmitSuccess } from '~/types/components/form';

const props = defineProps<{
  data: OrderDTO
  mode: 'cart' | 'checkout' | 'thanks'
  addressId?: number
  loading?: boolean
  buttonText?: string
  hideButton?: boolean
  hidePromo?: boolean
  full?: boolean
  showButtonPrice?: boolean
  showWebToAppBanner?: boolean
  isUnfinished?: boolean
  loadingId?: number
}>();

const emits = defineEmits<{
  (e: 'promoSuccess', data: OrderDTO): void,
  (e: 'apply', data: { checkoutLink: string, order: OrderDTO }): void,
  (e: 'delete-order', orderId?: number): void,
  (e: 'open-size-count-dialog', product: OrderPositionDTORes): void,
}>();

const { sale } = useWebToApp();
const items = ref(props.data.items);

const route = useRoute();
const { t } = useI18n();
const { $addEvent } = useNuxtApp();
const { isMounted, isDesktop } = useUiBreakpoints();
const { changeSizeOrCount } = useCart();
const { updateCart } = useCartStore();
const { isAuth } = useAccountStore();
const { addresses } = useAddresses();
const { createApiInstance } = useApi();
const cartApi = createApiInstance(Cart);
const { numberToCurrency } = useNumberFormatter();

const loadingPromo = ref(false);
const loadingProduct = ref(false);
const loadingAmountId = ref();

const loadingComp = computed(() => loadingProduct.value || (props.loadingId && props.loadingId === props.data.id));
const isThanksPage = computed(() => route.name === 'orders-orderId-thanks');
const discount = computed(() => props.data.discount);
const isDiscountWork = computed(() => !!(discount.value?.isValidYet && discount.value?.savingsValue));
const sellerId = computed(() => Number(props.data.seller?.id));
const currentAddress = computed(() => addresses.value.find((address) => address.id === props.addressId));
const deliveryCost = computed(() => currentAddress.value?.deliveryCost || props.data.deliveryCost);
const showFromDelivery = computed(() => {
  if (props.mode === 'cart') {
    return true;
  }

  if (props.mode === 'thanks') {
    return false;
  }

  return !currentAddress.value;
});
const totalAmount = computed(() => {
  const { clearAmount } = props.data;

  if (!deliveryCost.value) {
    return 0;
  }

  if (isDiscountWork.value && discount.value?.resultAmount) {
    return discount.value.resultAmount + deliveryCost.value;
  }

  if (clearAmount) {
    return clearAmount + deliveryCost.value;
  }

  return 0;
});

const smallAmount = computed(() => props.data.orderCreationProblems?.find((item) => item.type === 'NOT_ENOUGH_AMOUNT'));

const buttonTextComp = computed(() => {
  if (props.buttonText) {
    return smallAmount.value ? t('components.cart.cartOrder.orderItem.button.smallAmount') : props.buttonText;
  }

  return t('components.cart.cartOrder.orderItem.button.toPay');
});

const checkoutLink = computed(() => {
  const { id, seller } = props.data;

  if (!isAuth.value) return `/checkout-auth?sellerId=${props.data.seller?.id}`;
  if (smallAmount.value) return `/profile/${seller?.id}`;
  return `/checkout?sellerId=${seller?.id}${props.isUnfinished ? `&orderId=${id}` : ''}`;
});

async function handleChangeSizeOrCount(
  { values }: { values: { count?: number, sizeId?: number }},
  item?: OrderPositionDTORes,
) {
  loadingAmountId.value = item?.id;

  const { error } = await useAsyncData(
    () => changeSizeOrCount({
      orderPositionId: item?.id,
      sizeId: values.sizeId,
      count: values.count,
    }).then((res) => {
      updateCart(res);

      return true;
    }),
  );

  if (isCustomHTTPError(error.value) && error.value.response.data?.humanMessage) {
    alert(error.value.response.data.humanMessage);
  }

  loadingAmountId.value = undefined;
}

function formatPrice(price: number) {
  return price?.toLocaleString('ru-RU');
}

async function submitPromo({ values, actions }: TSubmitSuccess) {
  try {
    loadingPromo.value = true;

    const result = await cartApi.checkPromoCodeUsingGet({
      sellerId: sellerId.value,
      promoCode: values.promoCode,
    }, { format: 'json' }).then((res) => res.data.data);

    $addEvent(AnalyticsEvents.PromocodeApplySuccess, {
      value: values.promoCode,
    });

    if (result) {
      emits('promoSuccess', result);
    }
  } catch (error) {
    if (isCustomHTTPError(error) && error.response.data?.humanMessage) {
      actions.setFieldError('promoCode', error.response.data.humanMessage);
    }

    $addEvent(AnalyticsEvents.PromocodeApplyFailed, {
      value: values.promoCode,
    });

    console.error(error);
  } finally {
    loadingPromo.value = false;
  }

  $addEvent(AnalyticsEvents.Promocode, {
    value: values.promoCode,
  });
}

function handleClick() {
  emits('apply', {
    checkoutLink: checkoutLink.value,
    order: props.data,
  });

  if (props.full) {
    $addEvent(AnalyticsEvents.CartCheckout, {
      seller_id: sellerId.value,
    });
  }
}

function canShowSelectSize(item: OrderPositionDTORes) {
  return item.sizes && item.sizes.length > 1;
}

function canShowSelectAmount(item: OrderPositionDTORes) {
  const countSizes = getCountSizes(item);

  return item.sizes && countSizes && countSizes > 1;
}

function getCountSizes(item: OrderPositionDTORes) {
  if (item.count) {
    return item.sizes?.find((s) => s.id === item.size?.id)?.count ?? 0;
  }
  return 0;
}

function getQuantity(item: OrderPositionDTORes) {
  const countSizes = getCountSizes(item);

  if (countSizes && item.count) {
    return (item.count > countSizes) ? countSizes : item.count;
  }
  return item.count;
}

function openDialog(item: OrderPositionDTORes) {
  emits('open-size-count-dialog', item);

  $addEvent(AnalyticsEvents.ProductChangeClick, {
    seller_id: sellerId.value,
    product_id: item.productId,
  });
}

function handleOrderDelete(id: number) {
  emits('delete-order', id);

  $addEvent(AnalyticsEvents.OrderDeleteFromCart, {
    order_id: id,
    products: items.value ?? [],
  });
}

async function deleteProduct(id: number, product: OrderPositionDTORes) {
  loadingProduct.value = true;

  await useAsyncData(
    'deleteProductPageCart',
    () => changeSizeOrCount({ orderPositionId: id, count: 0 }).then((res) => {
      updateCart(res);

      return true;
    }),
  );

  loadingProduct.value = false;

  $addEvent(AnalyticsEvents.ProductDeleteFromCart, {
    product,
  });
}

function changeCount(val: number, item: OrderPositionDTORes) {
  handleChangeSizeOrCount({ values: { count: val } }, item);
}

function toggleLike(productId: number) {
  if (!items.value?.length) return;

  const products = items.value.filter((i) => i.productId === productId);

  if (products.length) {
    products?.forEach((p) => {
      // eslint-disable-next-line no-param-reassign
      p.isLiked = !p.isLiked;
    });
  }
}

function handleProductClick(productId?: number) {
  if (!productId) return;

  $addEvent(AnalyticsEvents.CheckoutThanksProductClick, {
    product_id: productId,
  });
}

function handleUserClick(userId: string | number) {
  $addEvent(AnalyticsEvents.UserClick, {
    seller_id: userId,
  });
}

watch(() => props.data.items, (value) => {
  items.value = value;
}, { deep: true });
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-cart-order {
  &__title {
    @include font-style($font-size-heading, $line-height-heading, $font-weight-bold);
    padding: $indent-medium 0;
    margin-bottom: $indent-compact;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__products {
    display: flex;
    flex-wrap: wrap;
    position: relative;

    @include media-query(lg-and-up) {
      margin: 0;
    }
  }

  &__product {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-top: -16px;
    margin-left: -16px;

    @include media-query(lg-and-up) {
      margin: 0;
    }
  }

  &__product-card {
    display: flex;
    align-items: flex-start;
    padding: 16px 16px 16px 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.06);
    border-radius: 2px;
    width: 100%;
    position: relative;
    flex-shrink: 0;
    margin-top: 16px;
    margin-bottom: 16px;
    margin-left: 16px;

    @include media-query(lg-and-up) {
      max-width: 100%;
      box-shadow: none;
      padding: $indent-mmedium $indent-mmedium $indent-mmedium 0;
      margin: 0;
    }
  }

  &__product-image-wrapper {
    flex-shrink: 0;
    width: 110px;
    padding: 0 $indent-medium;

    @include media-query(lg-and-up) {
      width: 128px;
      padding: 0 $indent-mmedium;
    }
  }

  &__product-image {
    display: block;
  }

  &__product-content {
    padding-left: $indent-compact;

    @include media-query(lg-and-up) {
      padding-left: $indent-mmedium;
    }
  }

  &__product-data {
    margin-bottom: $indent-medium;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__brand-name {
    @include font-style($font-size-subheading, $line-height-subheading, $font-weight-bold);
    margin-bottom: $indent-xsmall;

    @include media-query(lg-and-up) {
      margin-bottom: $indent-small;
    }
  }

  &__product-info {
    margin-bottom: $indent-medium;
    display: flex;

    &_mobile {
      display: flex;
      align-items: center;
      margin: 20px 0 16px;

      @include media-query(lg-and-up) {
        display: none;
      }

      .osk-cart-order__product-info-size {
        margin-bottom: 0;
      }
    }

    &_desktop {
      display: none;

      @include media-query(lg-and-up) {
        display: block;
      }
    }
  }

  &__label {
    @include font-style($font-size-caption, $line-height-caption, $font-weight-semibold);
    min-width: 97px;
    height: 27px;
    opacity: 0.6;
    border: 1px solid #DBDBDB;
    border-radius: $radius-small;
    display: flex;
    align-items: center;
    justify-content: center;

    & + & {
      margin-left: $indent-small;
    }

    &_active {
      color: $black;
      opacity: 1;

      &:not(:first-child) {
        margin-left: 8px;
      }
    }
  }

  &__product-prices {
    display: flex;
    flex-direction: column;

    &_full {
      flex-wrap: wrap;
      flex-direction: row;

      @include media-query(lg-and-up) {
        flex-direction: row-reverse;
      }
    }
  }

  &__rrp {
    @include font-style($font-size-caption, $line-height-caption, $font-weight-medium);
    text-decoration-line: line-through;
    color: $grey;
    margin-bottom: 2px;

    &_full {
      width: 100%;

      @include media-query(lg-and-up) {
        width: auto;
      }
    }
  }

  &__price {
    font-weight: $font-weight-bold;
  }

  &__price-discount {
    color: $red;
    font-weight: $font-weight-semibold;
    margin-left: $indent-compact;

    &_full {
      order: 3;

      @include media-query(lg-and-up) {
        margin-left: $indent-small;
        order: 0;
      }
    }
  }

  &__items {
    padding-top: $indent-large;
    padding-bottom: $indent-xlarge;
  }

  &__item {
    display: flex;
    align-items: baseline;

    & + & {
      margin-top: $indent-mmedium;
    }

    &:after {
      content: '';
      width: 100%;
      margin-left: $indent-small;
      margin-right: $indent-small;
      background-repeat: repeat-x;
      background-size: 3px 3px;
      background-image: radial-gradient(circle, $grey 1px, transparent 1px);
      height: 2px;
    }
  }

  &__item-name {
    flex-shrink: 0;
  }

  &__item-result {
    order: 1;
    flex-shrink: 0;
    font-weight: $font-weight-bold;
  }

  &__promo-form {
    display: flex;
    margin-bottom: $indent-mmedium;
  }

  &__promo-form-input {
    width: 100%;
  }

  &__promo-form-button {
    margin-top: 0 !important;
    flex-shrink: 0;
    margin-left: $indent-small;
  }

  &__footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: $indent-medium $indent-medium;
    background: $white;
    z-index: 1;

    @include media-query(md-and-up) {
      padding-left: $indent-compact;
      padding-right: $indent-compact;
    }

    @include media-query(lg-and-up) {
      position: static;
      padding: 0;
    }
  }

  &__header {
    padding-bottom: $indent-medium;

    @include media-query(lg-and-up) {
      border-bottom: 1px solid $black;
    }
  }

  &__product-id {
    display: none;
  }

  &__product-info-bold {
    font-weight: $font-weight-bold;
  }

  &__product-info-link {
    font-weight: $font-weight-semibold;
    margin-left: $indent-small;
    display: inline-block;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }
  }

  &__product-info-size {
    margin-bottom: 22px;
  }

  &__delete-order {
    display: inline-flex !important;
    height: auto !important;
    width: auto !important;
    line-height: normal !important;
  }

  &__buttons {
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-top: 14px;

    &_mobile {
      padding: 0 24px;
      margin: 0;
      height: 100%;
      justify-content: center;
    }
  }

  &__delete-product {
    display: inline-flex !important;
    height: auto !important;
    width: auto !important;
    line-height: normal !important;
    margin-left: $indent-medium;
  }

  &__product-info-wishlist {
    display: flex !important;
    display: block;
  }

  &__product-name-link {
    cursor: pointer;
    display: inline-block;

    &:hover {
      text-decoration: underline;
    }
  }

  &_full {
    @include media-query(lg-and-up) {
      display: flex;
      align-items: flex-start;
      flex-direction: row;
      justify-content: space-between;
    }

    .osk-cart-order__title {
      display: none;

      @include media-query(lg-and-up) {
        display: block;
      }
    }

    .osk-cart-order__left {
      @include media-query(lg-and-up) {
        width: 642px;
        flex-shrink: 0;
      }

      @media screen and (min-width: 1080px) {
        width: 662px;
        flex-shrink: 0;
      }
    }

    .osk-cart-order__right {
      @include media-query(lg-and-up) {
        max-width: 427px;
        padding: 0 32px;
        width: 100%;
      }

      @media screen and (min-width: 1080px) {
        padding: 0 42px;
      }
    }

    .osk-cart-order__product {
      overflow-y: auto;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      @include media-query(lg-and-up) {
        &:not(:last-child) {
          margin-bottom: 52px;
        }
      }
    }

    .osk-cart-order__product-card {
      @include media-query(lg-and-up) {
        padding: $indent-medium 0;
      }
    }

    .osk-cart-order__product-image-wrapper {
      @include media-query(lg-and-up) {
        width: 160px;
      }
    }

    .osk-cart-order__product-content {
      @include media-query(lg-and-up) {
        padding-top: $indent-mmedium;
        padding-left: $indent-mlarge;
        display: flex;
      }
    }

    .osk-cart-order__product-data {
      padding-right: 32px;
      width: 245px;

      @include media-query(lg-and-up) {
        margin-bottom: 0;
      }
    }

    .osk-cart-order__product-prices {
      @include media-query(lg-and-up) {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        flex-direction: row-reverse;
        padding-top: $indent-medium;

        .osk-cart-order__price {
          margin-right: $indent-small;
        }
      }
    }

    .osk-cart-order__product-info {
      @include media-query(lg-and-up) {
        flex-direction: column;
        margin-bottom: 0;
      }
    }

    .osk-cart-order__footer {
      position: static;
    }

    .osk-cart-order__product-id {
      @include media-query(lg-and-up) {
        display: block;
        margin-top: $indent-medium;
      }
    }

    .osk-cart-order__product-info-title {
      color: $grey;
      margin-bottom: 10px;
    }
  }
}
</style>
